import { Button, ConfigProvider, Form, Input, message, Modal, Space } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { setLocaleVal,selectLocale } from '../../store/localeSlice';
import { DownloadOutlined, CaretRightOutlined } from '@ant-design/icons';
import './installationVideo.less'
import android from 'image/Android.png'
import app from 'image/app.png'
import repair from 'image/repair.png'
import { useEffect, useState } from 'react';
import { post } from 'request/request';
import Ribbon from 'antd/es/badge/Ribbon';
import { useIntl } from 'react-intl';
import { FullScreenModal, FullScreenModal2 } from 'component/modal';
import { useParams } from 'react-router';

export default function InstallationVideo() {
	const intl = useIntl();
	const locale= useSelector(selectLocale);
	const [isModalVisible, setModalVisible] = useState(false);
	const [videoUrl, setVideoUrl] = useState('');
	const [isS1, setIsS1] = useState(true);
	let {type} = useParams<{type: string}>()
	type = type || 'default'
	
	// const [form] = Form.useForm();
	// const onFinish = (values: any) => {
	// 	post('snailcar/info/common/partnerSnailCar',{...values
	// }).then((data) => {
	// 	console.log(data)
	// 	message.success('successful!');
	// 	form.resetFields();
	// })
	// };

	const scrollToElement = (elementId: string) => {
		const element = document.getElementById(elementId);
		if(element){
			setTimeout(() => element.scrollIntoView({ behavior: 'smooth' }), 100);
		}
	}
	// type == 'app' && scrollToElement('appDownloadWrapper')

	useEffect(()=>{
		type == 'app' && scrollToElement('appDownloadWrapper')
	},[])

	const playVideoFun = (url: string, isS1: boolean) => {
		setIsS1(isS1)
		// setModalVisible(true);
		setVideoUrl(url);
		window.open(url);
	}

	const isMobile = navigator.userAgent.match(/(Mobi|Android|iPhone)/i);
	// const installVideoS1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056362282259636.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056359538679989.mp4';
	const installImgS1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056366348655234.jpg' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056574333298252.jpg';


	// const installVideoR1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056561425477843.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056560400902855.mp4';
	// const installVideoM1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056568100558145.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056568662317758.mp4';
	// const guideVideoR1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056570068154319.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056570385386975.mp4';
	// const guideVideoM1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056571166206615.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056571472794286.mp4';


	// const installVideoR1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056561425477843.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17091880661747673.mp4';
	// const installVideoM1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056568100558145.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17091884028695826.mp4';
	// const guideVideoR1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056570068154319.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17091889474615968.mp4';
	// const guideVideoM1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056571166206615.mp4' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17091889977155632.mp4';


	// const installVideoR1 = locale === 'zh' ? 'https://player.bilibili.com/player.html?aid=1151238439&bvid=BV1XZ421y7Pj&cid=1449655095&p=1' : 'https://www.youtube.com/embed/CiaUqY4sH5c?si=yQCSC-u0WvCl2IAh';
	// const installVideoM1 = locale === 'zh' ? 'https://player.bilibili.com/player.html?aid=1401430066&bvid=BV1gr421H7Sf&cid=1459897859&p=1' : 'https://www.youtube.com/embed/B2b_ZnaWKTw?si=n63v85X6pZrss-V2';
	// const guideVideoR1 = locale === 'zh' ? 'https://player.bilibili.com/player.html?aid=1001229813&bvid=BV1qx4y1r7iF&cid=1449644115&p=1' : 'https://www.youtube.com/embed/eaNU7Eoe9c0?si=zuWIA84m9nmpsOKn';
	// const guideVideoM1 = locale === 'zh' ? 'https://player.bilibili.com/player.html?aid=1401005355&bvid=BV1Hr421s7rG&cid=1449641659&p=1' : 'https://www.youtube.com/embed/w4nMCG85bKA?si=0XMBQ4rSyBCAhhvx';


	const installVideoS1 = locale === 'zh' ? 'https://www.bilibili.com/video/BV1pK42147Ft/?vd_source=d9e2b675f7f65cd54bcac7961203bd07' : 'https://youtu.be/qG-7aAL_MrQ';
	const installVideoR1 = locale === 'zh' ? 'https://www.bilibili.com/video/BV1XZ421y7Pj?vd_source=59b72ae3e5eed2bf396331d60088342e' : 'https://youtu.be/CiaUqY4sH5c';
	const installVideoM1 = locale === 'zh' ? 'https://www.bilibili.com/video/BV1gr421H7Sf/?share_source=copy_web&vd_source=59b72ae3e5eed2bf396331d60088342e' : 'https://youtu.be/B2b_ZnaWKTw';
	const guideVideoR1 = locale === 'zh' ? 'https://www.bilibili.com/video/BV1qx4y1r7iF?vd_source=59b72ae3e5eed2bf396331d60088342e' : 'https://youtu.be/eaNU7Eoe9c0';
	const guideVideoM1 = locale === 'zh' ? 'https://www.bilibili.com/video/BV1Hr421s7rG?vd_source=59b72ae3e5eed2bf396331d60088342e' : 'https://youtu.be/w4nMCG85bKA';
	

	const installImgR1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056566652526676.jpg' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056566297305148.jpg';
	const installImgM1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056569565527754.jpg' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056569409317895.jpg';
	const guideImgR1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056570831576318.jpg' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056570677728593.jpg';
	const guideImgM1 = locale === 'zh' ? 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056571906498249.jpg' : 'https://obs-snailcle.obs.ap-southeast-1.myhuaweicloud.com/SnailBicycl/course/17056571728077647.jpg';
	

	
	return <div>
		<div className='news-banner-wrapper'>
			<img className='install-img' src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16705676654665316.png" alt="" />
			<div className='news-banner-title'><span>{intl.formatMessage({id: 'afterSales.title'})}</span></div>
		</div>
		<div className="video-block">
			<div className='title'>{intl.formatMessage({id: 'afterSales.Video'})}</div>
			<div className='video-wrapper'>
				<div className='instaill-video-title'>{intl.formatMessage({id: 'header.menus.proS1'})}</div>
				{/* <div className='instaill-video-wrapper' style={{cursor: 'pointer'}} onClick={() => {isMobile ? (window.location.href = videoUrl) : playVideoFun(locale == 'zh' ? 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/file/apk/16583725253255534.mp4' : 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/file/apk/16583721485091224.mp4')}}> */}
				<div className='instaill-video-wrapper' style={{cursor: 'pointer'}} onClick={() => playVideoFun(installVideoS1, true)}>
					{/* <img src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16705719347062425.png" alt="" /> */}
					<img src={installImgS1} alt="" />
					<div className='video-title' > <span className='play-btn'><CaretRightOutlined /></span></div>
				</div>
				<div className='download-title'>{intl.formatMessage({id: 'afterSales.click.download'})}</div>
				<Space size={'large'}>
					<a className='down-btn' target={'_blank'} href="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16705686302852511">{intl.formatMessage({id: 'afterSales.Assembly'})}</a>
					<a className='down-btn' target={'_blank'} href="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16705685757671284">{intl.formatMessage({id: 'afterSales.Manual'})}</a>
				</Space>
			</div>
			<div style={{background: "rgba(180, 180, 180, 0.1)"}}>
				<div className='video-wrapper'>
					<div className='instaill-video-title'>{intl.formatMessage({id: 'header.menus.proR1'})}</div>
					<div className='instaill-video-wrapper' style={{cursor: 'pointer'}} onClick={() => {playVideoFun(installVideoR1, false)}}>
						<img src={installImgR1} alt="" />
						<div className='video-title' > <span className='play-btn'><CaretRightOutlined /></span></div>
					</div>
				</div>
			</div>
			<div className='video-wrapper'>
				<div className='instaill-video-title'>{intl.formatMessage({id: 'header.menus.proM1'})}</div>
				<div className='instaill-video-wrapper' style={{cursor: 'pointer'}} onClick={() => {playVideoFun(installVideoM1, false)}}>
					<img src={installImgM1} alt="" />
					<div className='video-title'> <span className='play-btn'><CaretRightOutlined /></span></div>
				</div>
			</div>
			<div className='title' style={{marginBottom: 20}}>{intl.formatMessage({id: 'afterSales.FunctionGuide'})}</div>
			<div style={{background: "rgba(180, 180, 180, 0.1)"}}>
				<div className='video-wrapper'>
					<div className='instaill-video-title'>{intl.formatMessage({id: 'header.menus.proR1'})}</div>
					<div className='instaill-video-wrapper' style={{cursor: 'pointer'}} onClick={() => {playVideoFun(guideVideoR1, false)}}>
						<img src={guideImgR1} alt="" />
						<div className='video-title'> <span className='play-btn'><CaretRightOutlined /></span></div>
					</div>
					{/* <div style={{position: 'relative',paddingBottom: '56%', marginTop: 40}}>
						<iframe src={guideVideoR1 + '&autoplay=0'} title="Snailcle"  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" style={{width: '100%', height: '100%', border:0,borderRadius: '16px', position: 'absolute', top: 0,bottom: 0,aspectRatio:'16/9'}}></iframe>
					</div> */}
				</div>
			</div>
			<div className='video-wrapper'>
				<div className='instaill-video-title'>{intl.formatMessage({id: 'header.menus.proM1'})}</div>
				<div className='instaill-video-wrapper' style={{cursor: 'pointer'}} onClick={() => {playVideoFun(guideVideoM1, false)}}>
					<img src={guideImgM1} alt="" />
					<div className='video-title'> <span className='play-btn'><CaretRightOutlined /></span></div>	
				</div>
				{/* <div style={{position: 'relative',paddingBottom: '56%', marginTop: 40}}>
					<iframe src={guideVideoM1 + '&autoplay=0'} title="Snailcle"  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" style={{width: '100%', height: '100%', border:0,borderRadius: '16px', position: 'absolute', top: 0,bottom: 0,aspectRatio:'16/9'}}></iframe>
				</div> */}
			</div>
			
		</div>
		<div className='app-download-wrapper' id="appDownloadWrapper">
			<img className='block-860-hide' src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16705730754273684.png" alt="" />
			<img className='block-860' src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16710703293609554.png" alt="" />
			<div className='app-download-container'>
				<div className='title'>{intl.formatMessage({id: 'afterSales.app.download'})}</div>
				<ul>
					<li>{intl.formatMessage({id: 'afterSales.con1'})}</li>
					<li>{intl.formatMessage({id: 'afterSales.con2'})}</li>
				</ul>
				<div>
					<a style={{cursor: 'pointer',marginRight: 30}} href="https://play.google.com/store/apps/details?id=com.pipishou.snailcycle" target="_blank"><img src={android} alt="" /></a>
					<a style={{cursor: 'pointer'}} href="https://apps.apple.com/cn/app/id1603185754" target="_blank"><img src={app} alt="" /></a>
				</div>
			</div>
		</div>
		{/* <div className="install-footer-wrapper">
			<div className="title">Repair and Maintenance.</div>
			<div style={{display: 'flex'}}>
				<div  className="content-block-left">
					<div>
						<img src={repair} alt="" />
						<div className='content'>If you need any help from us for aftersales assistance,write us email please:</div>
						<div>
							<span>Email: </span>
							<span className='font-bold'>support@snailcle.com</span>
						</div>
					</div>
				</div>
				<div className="content-block-right" >
					<ConfigProvider
						theme={{
							token: {
							colorPrimary: '#647283',
							},
						}}
						>
					<Form
						form={form}
						layout="vertical"
						name="register"
						onFinish={onFinish}
						initialValues={{
						residence: ['zhejiang', 'hangzhou', 'xihu'],
						prefix: '86',
						}}
						size={'large'}
						scrollToFirstError
						style={{width: '100%',maxWidth: '500px'}}
					>
						<Form.Item
						name="name"
						label="Your Name"
						>
						<Input />
						</Form.Item>

						<Form.Item
						name="company"
						label="Your Company Name"
						>
						<Input style={{ width: '100%' }} />
						</Form.Item>

						<Form.Item
						name="email"
						label="E-mail"
						rules={[
							{
							type: 'email',
							message: 'The input is not valid E-mail!',
							},
							{
							required: true,
							message: 'Please input your E-mail!',
							},
						]}
						>
						<Input />
						</Form.Item>

						<Form.Item
						name="comment"
						label="Your Comment"
						rules={[{ required: true, message: 'Please input your comment' }]}
						>
						<Input.TextArea placeholder="Please leave your comment here" style={{minHeight: '200px'}} />
						</Form.Item>
						<Form.Item >
						<Button type="primary" style={{width: '100%',marginTop: 60}} htmlType="submit" shape="round" block>Submit Contact</Button>
						</Form.Item>
					</Form>
					</ConfigProvider>
				</div>
			</div>
		</div> */}
		{/* <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#F6D3CE',
            },
          }}
        >
           {isModalVisible&&<Modal title="Install Video" open={isModalVisible} width='100%' style={{top: 50}} footer={null} onCancel={() => {setModalVisible(false)}}>
		   <video style={{width: '100%'}} webkit-playsinline="true" autoPlay playsInline controls={true} src={locale == 'zh' ? 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/file/apk/16583725253255534.mp4' : 'https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/file/apk/16583721485091224.mp4'} ></video>
          </Modal>}
        </ConfigProvider> */}
		<FullScreenModal setOpen={setModalVisible} open={isModalVisible&&isS1} url={videoUrl} />
		<FullScreenModal2 setOpen={setModalVisible} open={isModalVisible&&!isS1} url={videoUrl} />

	</div>
}